import 'babel-polyfill';
import Adapter from 'global-libs/adapter/adapter';
Adapter.StartAdapter(1600,16);
import Config from 'global-libs/config/config';
Config.initConfig({
    // root:"http://simulation.edusoa.com/simulation-online/apps/guang_ke_guan/",
    // resPathRoot:"http://three-dimensional.edusoa.com/projects/guang-ke-guan/"
    root:"./jsons",
    resPathRoot:"./guang-ke-guan/"
});
import React,{Component} from 'react';
import ReactDOM from 'react-dom';
import './app-style.scss';
import HomePage from './home-page/home-page';
class App extends Component{
    constructor(props,context){
        super(props,context);
    }
    render(){
        return (
            <div className="app-root">
                <HomePage/>
            </div>
        );
    }
}
ReactDOM.render(<App/>,document.getElementById('react-container'));
